import { Component, ViewChild } from "@angular/core";
import { BaseListComponent } from "../../SharedModule/BaseListComponent/base-list.component";
import { Pagination } from "../../model/Helpers/Pagination";
import { SortInfo } from "../../model/Helpers/SortInfo";
import { Filter } from "../../model/Helpers/Filter";
import { MatSort } from "@angular/material/sort";
import { merge } from "rxjs/observable/merge";
import {TransportStatsService} from '../../services/transport-stats.service';
import {TransportStatsDataSource} from '../../model/DataSources/TransportStatsDataSource';
import {TransportDataSource} from '../../model/DataSources/TransportDataSource';
import {TransportService} from '../../services/transport.service';
import {ContractState} from '../../model/Entities/ContractState';
import {Contract} from '../../model/Entities/Contract';
import { Router } from '@angular/router';
import {Transport} from '../../model/Entities/Transport';
import {TransportDialogComponent} from '../../ContractsModule/TransportDialogComponent/transport.dialog.component';
import {DialogService} from '../../services/dialog.service';
import {SnackService} from '../../services/snack.service';
import {
    TransportDeleteConfirmDialogComponent
} from '../../ContractsModule/TransportDeleteConfirmDialogComponent/transport-delete-confirm.dialog.component';
import {CompleteTransportDialogComponent} from '../CompleteTransportDialogComponent/completeTransport.dialog.component';
import {UserService} from '../../services/user.service';
import {User} from '../../model/Entities/User';
import {PrintService} from '../../services/print.service';
import {ContractStateComponent} from '../../SharedModule/ContractStateComponent/contract-state.component';

@Component({
    selector: 'transport',
    templateUrl: './transport.component.html',
    styleUrls: ['./transport.component.scss'],
})
export class TransportComponent extends BaseListComponent {
    displayedColumns: string[] = [
        "transport_from",
        "transport_to",
        "contract",
        "type",
        "note",
        "address",
        "drivers",
        "tags",
        "actions",
    ];


    @ViewChild(MatSort) sort: MatSort;
    user: User;
    pageSize = 25;

    constructor(
        private transportService: TransportService,
        private dialogService: DialogService,
        private snackService: SnackService,
        private userService: UserService,
        private router: Router,
        private printService: PrintService
    ) {
        super();


        const todayStart = new Date();
        todayStart.setHours(0, 0, 0, 0);
        const todayEnd = new Date();
        todayEnd.setHours(23, 59, 59, 999);

        this.defaultFilters = {

            from: todayStart,
            to: todayEnd,
            predefinedPeriod: "today",
            finished: 'all',
            type: 'all',
        };
        this.filters = {
            from: todayStart,
            to: todayEnd,
            predefinedPeriod: "today",
            finished: 'all',
            type: 'all',
        };
        this.resetFilters();

        this.dataSource = new TransportDataSource(this.transportService);
        this.user = this.userService.getLoggedUser();
    }

    ngAfterViewInit() {
        this.prepareDataLoading();
        this.loadData();
    }


    prepareDataLoading() {
        merge(
            this.paginator.page,
            this.sort.sortChange,
            this.dataChangedEventSubject
        ).subscribe(() => {
            if (!this.dataSource) {
                return;
            }
            this.dataSource.loadPage(
                new Pagination(this.paginator.pageSize, this.paginator.pageSize * this.paginator.pageIndex),
                new SortInfo(this.sort.active, this.sort.direction),
                this.getFilters(),
                {
                    expand: 'contract,users,repeatTransport'
                });
        });
    }

    loadData() {
        this.dataSource.loadPage(
            new Pagination(
                this.paginator.pageSize,
                this.pageSize * this.initialPageIndex
            ),
            null,
            this.getFilters(),
            {
                expand: 'contract,users,repeatTransport'
            }
        );
    }

    getFilters() {
        const filters: Filter[] = [];

        if (this.filters.from) {
            filters.push(new Filter("filter_transport_from", this.filters.from.toISOString()));
        }
        if (this.filters.to) {
            filters.push(new Filter("filter_transport_to", this.filters.to.toISOString()));
        }

        if (this.filters.finished) {
            filters.push(new Filter("finished", this.filters.finished));
        }

        if (this.filters.type) {
            filters.push(new Filter("filter_type", this.filters.type));
        }

        return filters;
    }

    setPredefinedPeriod(period: string): void {
        this.filters.predefinedPeriod = period;

        const now = new Date();

        switch (period) {
            case "today":
                const todayStart = new Date(now);
                todayStart.setHours(0, 0, 0, 0);
                const todayEnd = new Date(now);
                todayEnd.setHours(23, 59, 59, 999);
                this.filters.from = todayStart;
                this.filters.to = todayEnd;
                break;
            case "lastMonth":
                const lastMonth = new Date(
                    now.getFullYear(),
                    now.getMonth() - 1,
                    1
                );
                const lastMonthEnd = new Date(
                    now.getFullYear(),
                    now.getMonth(),
                    0
                );
                this.filters.from = lastMonth;
                this.filters.to = lastMonthEnd;
                break;

            case "thisYear":
                const yearStart = new Date(now.getFullYear(), 0, 1);
                const yearEnd = new Date(now.getFullYear(), 11, 31);
                this.filters.from = yearStart;
                this.filters.to = yearEnd;
                break;

            case "thisWeek":
                const firstDayOfWeek = new Date(now);
                firstDayOfWeek.setDate(now.getDate() - now.getDay() + 1); // pondělí
                firstDayOfWeek.setHours(0, 0);
                const lastDayOfWeek = new Date(firstDayOfWeek);
                lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6); // Neděle
                lastDayOfWeek.setHours(23, 59);
                this.filters.from = firstDayOfWeek;
                this.filters.to = lastDayOfWeek;
                break;
            case "thisMonth":
                const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
                const monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0);
                this.filters.from = monthStart;
                this.filters.to = monthEnd;
                break;
            case "all":
                this.filters.from = null;
                this.filters.to = null;
                break;

            case "custom":
                // Keep current dates, just change the period
                break;
        }

        this.reloadPage();
    }

    onDateChange(): void {
        // When user manually changes dates, switch to custom period
        this.filters.predefinedPeriod = "custom";
        this.reloadPage();
    }

    protected readonly contractStateClass = ContractState;

    showContractDetail(contract: Contract): void {
        this.router.navigate([`/contract/${contract.id}`]);
    }

    editTransport(transport) {
        this.openTransportDialog(transport);
    }

    deleteTransport(transport) {
        this.dialogService.showDialog(TransportDeleteConfirmDialogComponent, {
            'transport': transport,
        }).afterClosed().subscribe((result) => {
                if (result) {
                    this.transportService.delete(transport.id).subscribe(() => {
                        this.snackService.showSuccess(`Doprava byla smazána`);
                        this.reloadPage();
                    });
                }
            }
        );
    }

    private openTransportDialog(transport: Transport): void {
        this.dialogService.showDialog(TransportDialogComponent, {
            'transport': transport,
            'contract': transport.contract
        }, 1000, 800).afterClosed().subscribe((result) => {
                if (!result) {
                    this.reloadPage();
                    return;
                }
                if (!result.id) {
                    // create
                    this.transportService.save(transport).subscribe((t: Transport) => {
                        this.snackService.showSuccess(`Doprava byla přidána`);
                        this.reloadPage();
                    });
                } else {
                    // update
                    this.transportService.update(result.id, transport).subscribe((t: Transport) => {
                        this.snackService.showSuccess(`Doprava byla upravena`);
                        this.reloadPage();
                    });
                }
            }
        );
    };

    addTransport() {
        let transport = new Transport();
        this.openTransportDialog(transport);

    }

    resetFilters() {

        const todayStart = new Date();
        todayStart.setHours(0, 0, 0, 0);
        const todayEnd = new Date();
        todayEnd.setHours(23, 59);

        this.filters.predefinedPeriod = "today";
        this.filters.from = todayStart;
        this.filters.to = todayEnd;
        this.filters.finished = 'all';
        this.filters.type = 'all';
        this.reloadPage();
    }

    completeTransport(transport) {
        if (transport.contract) {
            transport.completePerson = transport.contract.delivery_contact_person;
        }
        transport.completeDatetime = new Date().toISOString().slice(0, 16);
        transport.completeUserId = this.user;

        this.dialogService.showDialog(CompleteTransportDialogComponent, {
            'transport': transport
        }).afterClosed().subscribe((result: any) => {
            if (result) {
                this.transportService.update(result.id, transport).subscribe((t: Transport) => {
                    this.snackService.showSuccess(`Dokončení dopravy uloženo!`);
                    this.reloadPage();
                });
            } else {
                this.reloadPage();
            }
        });
    }


    printTransports() {
        const filters: Filter[] = [];

        if (this.filters.from) {
            filters.push(new Filter("from", this.filters.from.toISOString()));
        }
        if (this.filters.to) {
            filters.push(new Filter("to", this.filters.to.toISOString()));
        }
        if (this.filters.finished) {
            filters.push(new Filter("finished", this.filters.finished));
        }
        if (this.filters.type) {
            filters.push(new Filter("filter_type", this.filters.type));
        }


        const url = this.printService.getTransportsPrintUrl(filters);
        window.open(url, "_blank");
    }

    changeToDate() {
        this.filters.to = this.filters.from;
    }
}



// WEBPACK FOOTER //
// /app/src/TransportModule/TransportComponent/transport.component.ts